import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeburringSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "deburring-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "49.87 29.82 8.56 53.67 8.56 65.59 50.13 89.59 91.44 65.74 91.44 53.82 49.87 29.82"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M91.44,52.62a1.2,1.2,0,0,0-1.2,1.2V65.05L51.33,87.51V77.67a1.2,1.2,0,1,0-2.4,0v9.84L9.76,64.9V53.67a1.2,1.2,0,1,0-2.4,0V65.59a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.78a1.2,1.2,0,0,0,.6-1V53.82A1.2,1.2,0,0,0,91.44,52.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M26.85,44.31a1.25,1.25,0,0,0,.6-.16l3.33-1.92a1.21,1.21,0,0,0,.44-1.64,1.18,1.18,0,0,0-.73-.56,1.2,1.2,0,0,0-.91.12l-3.33,1.92a1.21,1.21,0,0,0-.44,1.64A1.22,1.22,0,0,0,26.85,44.31Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M20.2,48.15a1.25,1.25,0,0,0,.6-.16l3.33-1.92a1.21,1.21,0,0,0,.44-1.64,1.18,1.18,0,0,0-.73-.56,1.21,1.21,0,0,0-.91.12L19.6,45.91a1.21,1.21,0,0,0-.44,1.64A1.22,1.22,0,0,0,20.2,48.15Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M30.78,65.11l-3.33-1.92a1.2,1.2,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56,1.21,1.21,0,0,0,.44,1.64l3.33,1.92a1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6A1.21,1.21,0,0,0,30.78,65.11Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M40.15,36.63a1.15,1.15,0,0,0,.6-.16l3.33-1.92a1.21,1.21,0,0,0,.44-1.64,1.18,1.18,0,0,0-.73-.56,1.21,1.21,0,0,0-.91.12l-3.33,1.92A1.21,1.21,0,0,0,39.11,36,1.22,1.22,0,0,0,40.15,36.63Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M33.5,40.47a1.15,1.15,0,0,0,.6-.16l3.33-1.92a1.21,1.21,0,0,0,.44-1.64,1.18,1.18,0,0,0-.73-.56,1.21,1.21,0,0,0-.91.12L32.9,38.23a1.21,1.21,0,0,0-.44,1.64A1.22,1.22,0,0,0,33.5,40.47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M37.43,69,34.1,67a1.2,1.2,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56,1.21,1.21,0,0,0,.44,1.64L36.23,71a1.25,1.25,0,0,0,.6.16,1.2,1.2,0,0,0,.6-2.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M44.08,72.79l-3.33-1.92A1.2,1.2,0,0,0,39.55,73l3.33,1.92a1.25,1.25,0,0,0,.6.16,1.2,1.2,0,0,0,.6-2.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M13.55,52a1.25,1.25,0,0,0,.6-.16l3.33-1.92a1.21,1.21,0,0,0,.44-1.64,1.22,1.22,0,0,0-.74-.56,1.18,1.18,0,0,0-.9.12L13,49.75a1.21,1.21,0,0,0-.44,1.64A1.22,1.22,0,0,0,13.55,52Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M52.86,32.93l3.32,1.92a1.15,1.15,0,0,0,.6.16,1.2,1.2,0,0,0,.6-2.24l-3.32-1.92a1.23,1.23,0,0,0-.92-.12,1.16,1.16,0,0,0-.72.56A1.19,1.19,0,0,0,52.86,32.93Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M59.51,36.77l3.32,1.92a1.25,1.25,0,0,0,.6.16,1.2,1.2,0,0,0,.6-2.24l-3.32-1.92a1.2,1.2,0,0,0-1.2,2.08Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M17.48,57.43l-3.33-1.92a1.2,1.2,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56A1.21,1.21,0,0,0,13,57.59l3.33,1.92a1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6A1.21,1.21,0,0,0,17.48,57.43Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M11.27,52.11h0a1.22,1.22,0,0,0-.74-.56,1.18,1.18,0,0,0-.9.12L8,52.63a1.2,1.2,0,0,0,0,2.08l1.67,1a1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6A1.21,1.21,0,0,0,11,53.67,1.21,1.21,0,0,0,11.27,52.11Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M24.13,61.27,20.8,59.35a1.2,1.2,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56,1.21,1.21,0,0,0,.44,1.64l3.33,1.92a1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6A1.21,1.21,0,0,0,24.13,61.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M76.52,61.45a1.21,1.21,0,0,0-.91.12l-3.32,1.92a1.2,1.2,0,0,0,.6,2.24,1.25,1.25,0,0,0,.6-.16l3.32-1.92A1.2,1.2,0,0,0,77.25,62,1.18,1.18,0,0,0,76.52,61.45Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M83.17,57.61a1.21,1.21,0,0,0-.91.12l-3.32,1.92a1.2,1.2,0,0,0,.6,2.24,1.25,1.25,0,0,0,.6-.16l3.32-1.92a1.2,1.2,0,0,0,.44-1.64A1.18,1.18,0,0,0,83.17,57.61Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M77.33,44.29l-1-.59.12,0,3.46-1a.79.79,0,0,0,0-1.53l-3.46-1a6.54,6.54,0,0,1-4.49-4.49l-1-3.46a.79.79,0,0,0-1.53,0l-1,3.46a6.63,6.63,0,0,1-1.57,2.73,1.18,1.18,0,0,0-1.13.59,1.05,1.05,0,0,0-.15.43,6.48,6.48,0,0,1-1.64.74l-3.46,1a.8.8,0,0,0,0,1.53l3.46,1a6.54,6.54,0,0,1,4.49,4.49l1,3.46a.8.8,0,0,0,1.53,0l1-3.46a6.56,6.56,0,0,1,2-3.07l2.24,1.29a1.23,1.23,0,0,0,1.64-.44A1.2,1.2,0,0,0,77.33,44.29Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M84,48.13l-3.32-1.92a1.21,1.21,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56,1.2,1.2,0,0,0,.44,1.64l3.32,1.92a1.28,1.28,0,0,0,.6.16,1.2,1.2,0,0,0,.6-2.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M90.63,52l-3.32-1.92a1.21,1.21,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56,1.21,1.21,0,0,0,.44,1.64l2.94,1.7-.14.06-3.32,1.92a1.2,1.2,0,0,0,.6,2.24,1.25,1.25,0,0,0,.6-.16L90.11,56a1.2,1.2,0,0,0,.44-1.64,1.27,1.27,0,0,0-.13-.19,1.18,1.18,0,0,0,.65-.53A1.2,1.2,0,0,0,90.63,52Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50.73,28.93l-.26-.15a1.22,1.22,0,0,0-1.2,0L46.2,30.55a1.2,1.2,0,0,0,.61,2.24,1.11,1.11,0,0,0,.59-.16L50,31.16a1.2,1.2,0,0,0,1.34-1.5A1.18,1.18,0,0,0,50.73,28.93Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50.73,76.63l-3.32-1.92a1.23,1.23,0,0,0-.92-.12,1.16,1.16,0,0,0-.72.56,1.19,1.19,0,0,0,.43,1.64l3.33,1.92a1.25,1.25,0,0,0,.6.16,1.2,1.2,0,0,0,.6-2.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M55.66,73.09,52.34,75a1.2,1.2,0,0,0,.6,2.24,1.28,1.28,0,0,0,.6-.16l3.32-1.92a1.2,1.2,0,1,0-1.2-2.08Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M63.22,69.13a1.21,1.21,0,0,0-.91.12L59,71.17a1.2,1.2,0,0,0,.6,2.24,1.28,1.28,0,0,0,.6-.16l3.32-1.92A1.21,1.21,0,0,0,64,69.69,1.18,1.18,0,0,0,63.22,69.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M69.87,65.29a1.21,1.21,0,0,0-.91.12l-3.32,1.92a1.2,1.2,0,0,0,.6,2.24,1.25,1.25,0,0,0,.6-.16l3.32-1.92a1.2,1.2,0,0,0,.44-1.64A1.18,1.18,0,0,0,69.87,65.29Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M66.92,57.83a.57.57,0,0,0-.42-.55l-2.12-.61A3.92,3.92,0,0,1,61.7,54l-.61-2.12a.57.57,0,0,0-.55-.42h0a.58.58,0,0,0-.56.42L59.37,54a3.92,3.92,0,0,1-2.68,2.68l-2.12.61a.58.58,0,0,0,0,1.11l2.12.61a3.92,3.92,0,0,1,2.68,2.68L60,63.8a.58.58,0,0,0,.56.42h0a.57.57,0,0,0,.55-.42l.61-2.12A3.92,3.92,0,0,1,64.38,59l2.12-.61A.57.57,0,0,0,66.92,57.83Z"
			})
		]
	})]
});
export default SvgDeburringSm;
